import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Basket} from "../../../../context/basket";
import Image from 'next/image';
import ReactCardFlip from 'react-card-flip';
import InformationCard from './card';
import ProductCard from './product';
import Button from "@mui/material/Button";
import { toast } from 'react-toastify';
import Box from "@mui/material/Box";

const ProductItem = (props) =>
{
    const basket = useContext(Basket);
    const parse = require('html-react-parser');
    const [itemInBasket, setItemInBasket] = useState(false);
    const [cardFlip, setCardFlip] = useState(false);
    let inBasketItems = props.inBasketItems;

    function setInBasketItems (productId, add = false)
    {
        let basketItems = props.inBasketItems;
        if (add && basketItems.indexOf(productId) === -1) {
            // Otherwise React won't `react` to the state change without an array reference change.
            let tmpBasketItems = basketItems.slice();
            tmpBasketItems.push(productId);
            basketItems = tmpBasketItems;
        } else if (!add) {
            basketItems = props.inBasketItems.filter(id => id !== productId);
        }

        props.setInBasketItems(basketItems);
        inBasketItems = basketItems;
        props.setActiveProducts(basketItems, add, true);
    }

    const addProductName = () => {
        if (typeof props.addToCartTitle !== 'undefined') {
            return props.addToCartTitle;
        }

        return 'Add to plan';
    }

    const add = (productId) => {
        setInBasketItems(productId, true);
        setItemInBasket(true);
    }

    const remove = (productId) => {
        setInBasketItems(productId, false);
        setItemInBasket(false);
    }

    const hasMedication = () => {
        toast.error('Medication is already used in another product.');
    }

    const flipCard = (e) => {
        if (cardFlip === true) {
            setCardFlip(false);
        } else {
            setCardFlip(true);
        }
    }

    useEffect(() => {
        if (props.inBasketItems.indexOf(props.product.id) !== -1 && !itemInBasket) {
            setItemInBasket(true);
        }
    })

    const greyOutProducts = (productId) => {
        if (itemInBasket) {
            return 'item-container product-card item item-in-basket';
        } else if (props.shouldGreyOut.indexOf(productId) !== -1) {
            return 'item-container product-card item grey-out';
        }

        return 'item-container product-card item';
    }

    const getProductId = (productId) => {
        // Cross sell child overrules the primary product id, we can facade frequencies this way.
        if (typeof props.crossSellChild !== 'undefined'
            && props.crossSellChild !== null) {
            return props.crossSellChild.id;
        }

        return productId;
    }

    return props?.product?.id
        && props?.product?.imagesFe.length > 0
        && (<ReactCardFlip isFlipped={cardFlip} flipDirection="horizontal" flipSpeedBackToFront={1} flipSpeedFrontToBack={1}>
                <Box className={greyOutProducts(props.product.id) + ' bg-lt-grey rounded margin-top-2 padding-2'} data-product-id={'product-' + props.product.id}>
                    <ProductCard
                        product={props.product}
                        basket={basket}
                        addProductName={addProductName}
                        inBasketItems={inBasketItems}
                        greyOutProducts={greyOutProducts}
                        flipCard={flipCard}
                        oneOffItem={props.oneOffItem}
                        crossSellChild={props.crossSellChild}
                        key={'product-card-' + props.product.id}
                    />
                    <Box className="item-actions">
                        <Box className="item-action-button">
                            {greyOutProducts(props.product.id) === 'item-container product-card item grey-out' && (
                                <button className="btn disabled" variant="contained" color="primary" onClick={() => hasMedication()}>
                                    <small>Medication already selected</small>
                                </button>
                            )}
                            {props.inBasketItems.includes(getProductId(props.product.id))
                                && greyOutProducts(getProductId(props.product.id)) !== 'item-container product-card item grey-out'
                                && (
                                    <button className="btn remove" variant="contained" color="primary"
                                            onClick={() => remove(getProductId(props.product.id))}>
                                        Remove
                                    </button>
                                )
                            }
                            {!props.inBasketItems.includes(getProductId(props.product.id))
                                && greyOutProducts(getProductId(props.product.id)) !== 'item-container product-card item grey-out'
                                && (
                                    <button className="btn" variant="contained" color="primary"
                                            onClick={() => add(getProductId(props.product.id))}>
                                        {addProductName()}
                                    </button>
                                )
                            }
                        </Box>
                    </Box>
                </Box>
                <Box className="item-container product-card-info item">
                    <InformationCard product={props.product} flipCard={() => flipCard()}/>
                </Box>
            </ReactCardFlip>
        );
}

export default ProductItem;